// src/utils/elementTheme.ts
type RGB = [number, number, number];

const clamp = (n: number) => Math.max(0, Math.min(255, n));

const parseRgbString = (rgb: string): RGB => {
  // Acepta "222,52,0" o "222, 52, 0"
  const parts = rgb.split(',').map((x) => parseInt(x.trim(), 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) {
    throw new Error(`RGB inválido: "${rgb}". Se esperaba "R,G,B"`);
  }
  return [clamp(parts[0]), clamp(parts[1]), clamp(parts[2])];
};

const toRgb = (c: RGB) => `rgb(${c[0]}, ${c[1]}, ${c[2]})`;

// Mezcla hacia blanco (tint)
const tint = (c: RGB, percent: number): RGB => ([
  clamp(Math.round(c[0] + (255 - c[0]) * percent)),
  clamp(Math.round(c[1] + (255 - c[1]) * percent)),
  clamp(Math.round(c[2] + (255 - c[2]) * percent)),
]);

// Mezcla hacia negro (shade)
const shade = (c: RGB, percent: number): RGB => ([
  clamp(Math.round(c[0] * (1 - percent))),
  clamp(Math.round(c[1] * (1 - percent))),
  clamp(Math.round(c[2] * (1 - percent))),
]);

export const applyElementPlusPrimaryFromApi = (primaryRgb: string) => {
  const base = parseRgbString(primaryRgb);
  const root = document.documentElement.style;

  // Base
  root.setProperty('--el-color-primary', toRgb(base));

  // Hover / estados claros (Element Plus usa estos para hover, focus, etc.)
  root.setProperty('--el-color-primary-light-3', toRgb(tint(base, 0.3)));
  root.setProperty('--el-color-primary-light-5', toRgb(tint(base, 0.5)));
  root.setProperty('--el-color-primary-light-7', toRgb(tint(base, 0.7)));
  root.setProperty('--el-color-primary-light-8', toRgb(tint(base, 0.8)));
  root.setProperty('--el-color-primary-light-9', toRgb(tint(base, 0.9)));

  // Active / estados oscuros
  root.setProperty('--el-color-primary-dark-2', toRgb(shade(base, 0.2)));
};
